<template>
  <div class="text-xs-center">
    <v-progress-linear color="success" :indeterminate="true"></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: 'Loading',
};
</script>